"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var aftersaleApi = _interopRequireWildcard(require("@/api/aftersaleApi.js"));
var _validate = require("@/utils/validate");
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {},
  data: function data() {
    return {
      loading: false,
      visible: false,
      detailInfo: {},
      handerOptions: [],
      stateOption: [{
        value: 1,
        name: '短信通知顾客'
      }, {
        value: 2,
        name: '微信通知顾客'
      }],
      checkboxGroup: [],
      pram: {}
    };
  },
  mounted: function mounted() {
    this.checkboxGroup = [];
  },
  methods: {
    initOpen: function initOpen() {
      var detailInfo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var aftersaleType = detailInfo.aftersaleType,
        status = detailInfo.status;
      this.filterStatus(status);
      this.detailInfo = detailInfo;
      this.checkboxGroup = [];
      this.pram = {};
      // 退货退款/仅退款，展示 下步状态为待退款
      aftersaleType = Number(aftersaleType);
      if ([1, 2].includes(aftersaleType)) {
        this.$set(this.pram, 'status', 4);
      }
      ;
      this.visible = true;
    },
    handerSubmit: (0, _validate.Debounce)(function (form) {
      var _this = this;
      this.$refs[form].validate(function (valid) {
        if (!valid) return;
        _this.loading = true;
        var _ref = _this.pram || {},
          amount = _ref.amount,
          description = _ref.description,
          operatorId = _ref.operatorId,
          status = _ref.status;
        aftersaleApi.getsaleTrack({
          aftersaleId: _this.detailInfo.id,
          notifyType: _this.checkboxGroup || [],
          description: description,
          operatorId: operatorId,
          status: status
        }).then(function (data) {
          _this.$message.success('操作成功');
          _this.loading = false;
          _this.visible = false;
          _this.$emit('doRefresh');
        }).catch(function () {
          _this.loading = false;
        });
      });
    }),
    closeEdit: function closeEdit() {
      this.visible = false;
    },
    filterStatus: function filterStatus(status) {
      var arr = [];
      switch (status) {
        case 1:
          arr.push({
            value: 2,
            name: '待顾客退货'
          });
          arr.push({
            value: 3,
            name: '待仓库收货'
          });
          arr.push({
            value: 4,
            name: '待退款'
          });
          arr.push({
            value: 5,
            name: '待仓库发货'
          });
          arr.push({
            value: 6,
            name: '待顾客收货'
          });
          arr.push({
            value: 8,
            name: '已驳回'
          });
          break;
        case 2:
          arr.push({
            value: 3,
            name: '待仓库收货'
          });
          arr.push({
            value: 4,
            name: '待退款'
          });
          arr.push({
            value: 8,
            name: '已驳回'
          });
          break;
        case 3:
          arr.push({
            value: 5,
            name: '待仓库发货'
          });
          arr.push({
            value: 4,
            name: '待退款'
          });
          arr.push({
            value: 8,
            name: '已驳回'
          });
          arr.push({
            value: 7,
            name: '售后完成'
          });
          break;
        case 5:
          arr.push({
            value: 2,
            name: '待顾客退货'
          });
          arr.push({
            value: 3,
            name: '待仓库收货'
          });
          arr.push({
            value: 4,
            name: '待退款'
          });
          arr.push({
            value: 6,
            name: '待顾客收货'
          });
          arr.push({
            value: 8,
            name: '已驳回'
          });
          arr.push({
            value: 7,
            name: '售后完成'
          });
          break;
        case 6:
          arr.push({
            value: 2,
            name: '待顾客退货'
          });
          arr.push({
            value: 3,
            name: '待仓库收货'
          });
          arr.push({
            value: 4,
            name: '待退款'
          });
          arr.push({
            value: 8,
            name: '已驳回'
          });
          arr.push({
            value: 7,
            name: '售后完成'
          });
          break;
        case 8:
          arr.push({
            value: 2,
            name: '待顾客退货'
          });
          arr.push({
            value: 3,
            name: '待仓库收货'
          });
          arr.push({
            value: 4,
            name: '待退款'
          });
          arr.push({
            value: 5,
            name: '待仓库发货'
          });
          arr.push({
            value: 6,
            name: '待顾客收货'
          });
          break;
        default:
      }
      this.handerOptions = arr;
    }
  }
};